export enum SearchSegmentType {
  Custom = 'custom',
  All = 'all',
  New = 'new',
  NotContacted = 'not_contacted',
  Followed = 'followed',
  Overdue = 'overdue',
  // RecentlyViewed = 'recently_viewed',
  Gdpr = 'gdpr',
  RecentlyDeleted = 'recently_deleted',
}
